import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "td__checkbox" };
const _hoisted_2 = ["title"];
const _hoisted_3 = { class: "td__config-surcharge" };
const _hoisted_4 = { class: "td__irregular-surcharge" };
const _hoisted_5 = { class: "td__delivery-status" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_checkbox = _resolveComponent("v-checkbox");
    const _directive_tr_highlight = _resolveDirective("tr-highlight");
    return _withDirectives((_openBlock(), _createElementBlock("tr", {
        class: "tr",
        onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => ($setup.handleClickRow && $setup.handleClickRow(...args)))
    }, [
        _createElementVNode("td", _hoisted_1, [
            _createVNode(_component_v_checkbox, {
                "model-value": $props.rowData.isSelected([$props.rowData.internalItem]),
                density: "compact",
                "hide-details": "",
                onclick: $setup.withModifiers(() => $props.rowData.toggleSelect($props.rowData.internalItem), ['stop'])
            }, null, 8 /* PROPS */, ["model-value", "onclick"])
        ]),
        _createElementVNode("td", {
            title: $props.rowData.item.name,
            class: "td__name"
        }, _toDisplayString($props.rowData.item.name), 9 /* TEXT, PROPS */, _hoisted_2),
        _createElementVNode("td", _hoisted_3, [
            _createElementVNode("span", {
                class: _normalizeClass($setup.applyIrregularSurchargeStatusCss)
            }, _toDisplayString($props.rowData.item.formattedAddChargeApplyYn), 3 /* TEXT, CLASS */)
        ]),
        _createElementVNode("td", _hoisted_4, [
            _createElementVNode("span", {
                class: _normalizeClass($setup.irregularSurchargeStatusCss)
            }, _toDisplayString($props.rowData.item.formattedAddDeliveryChargeAndRate), 3 /* TEXT, CLASS */)
        ]),
        _createElementVNode("td", _hoisted_5, [
            _createElementVNode("span", {
                class: _normalizeClass($setup.fulfillmentStatusCss)
            }, _toDisplayString($props.rowData.item.getFulfillmentStateToText), 3 /* TEXT, CLASS */)
        ])
    ])), [
        [_directive_tr_highlight, $setup.cssClassHighlight]
    ]);
}
